<script lang="ts">
  import { draw } from "svelte/transition";
  interface Props {
    stroke?: string;
    width?: string;
    height?: string;
  }

  let { stroke = "#fff", width = "16", height = "13" }: Props = $props();
</script>

<svg {width} {height} viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1 7.08322L5.30769 11.0554L15 0.944336" {stroke} stroke-width="2" />
</svg>
